// src/components/Navbar.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar({ cartItems }) {
  const toggleDarkMode = () => {
    document.body.classList.toggle("dark");
    localStorage.setItem("darkMode", document.body.classList.contains("dark"));
  };

  // Load saved dark mode preference on page load
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode") === "true";
    if (savedMode) document.body.classList.add("dark");
  }, []);

  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        🛍 Before You Buy
      </Link>

      <div className="nav-right">
        <button className="dark-toggle" onClick={toggleDarkMode}>
          🌓
        </button>

        <Link to="/cart" className="cart-link">
          🛒
          {cartItems.length > 0 && (
            <span className="cart-count">{cartItems.length}</span>
          )}
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
